import React from "react";
import ReactDOM from "react-dom/client";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.less";

import Dashboard from "./pages/Dashboard";
import DashboardKPI from "./pages/DashboardKPI";
import DashboardFilteredAndGrouped from "./pages/DashboardFilteredAndGrouped";
import AnalysisDetails from "./pages/AnalysisDetails";
import YoutubeImports from "./pages/YoutubeImports";
import { SegmentEventsStudio, SegmentEventsSongwriter } from "./pages/SegmentEvents";
import UserSegmentsByWeek from "./pages/UserSegmentsByWeek";
import OnboardingFunnel from "./pages/OnboardingFunnel";
import CACPage from "./pages/CACPage";
import SignIn from "./pages/SignIn";


import View from "./layouts/View";
import { AuthProvider } from "./auth/AuthContext";
import PrivateRoute from "./auth/PrivateRoute";
import { DashboardDataProvider } from "./data/DashboardDataProvider";

const now = new Date();
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), 1);
const daysSinceOneYearAgo = Math.round((today - oneYearAgo) / (1000 * 60 * 60 * 24));
const longAgo = new Date("2013-01-01");
const daysSinceLongAgo = Math.round((today - longAgo) / (1000 * 60 * 60 * 24));

const WrappedPage = ({ name, page }) => (
  <PrivateRoute>
    <DashboardDataProvider>
      <View name={name} page={page} />
    </DashboardDataProvider>
  </PrivateRoute>
);

const routes = [
  {
    path: "/",
    element: <WrappedPage name="Dashboard" page={<Dashboard />} />,
  },
  {
    path: "/analysis-details",
    element: <WrappedPage name="Analysis Details" page={<AnalysisDetails />} />,
  },
  {
    path: "/data/daily",
    element: <WrappedPage name="Daily (90 days)" page={<DashboardFilteredAndGrouped filter={90} />} />,
  },
  {
    path: "/data/weekly",
    element: <WrappedPage name="Weekly (1 year)" page={<DashboardFilteredAndGrouped filter={daysSinceOneYearAgo} group="week" />} />,
  },
  {
    path: "/data/monthly",
    element: <WrappedPage name="Monthly (1 year)" page={<DashboardFilteredAndGrouped filter={daysSinceOneYearAgo} group="month" />} />,
  },
  {
    path: "/data/all-time",
    element: <WrappedPage name="All time" page={<DashboardFilteredAndGrouped filter={daysSinceLongAgo} group="month" />} />,
  },
  {
    path: "/youtube-imports",
    element: <WrappedPage name="YouTube Imports" page={<YoutubeImports />} />,
  },
  {
    path: "/user-segments-studio",
    element: <WrappedPage name="Studio Segments" page={<UserSegmentsByWeek />} />,
  },
  {
    path: "/user-segments-songwriter",
    element: <WrappedPage name="Songwriter Segments" page={<UserSegmentsByWeek client="songwriter" />} />,
  },
  {
    path: "/segment-events-studio",
    element: <WrappedPage name="Studio Events" page={<SegmentEventsStudio />} />,
  },
  {
    path: "/segment-events-songwriter",
    element: <WrappedPage name="Songwriter Events" page={<SegmentEventsSongwriter />} />,
  },
  {
    path: "/onboarding-funnel",
    element: <WrappedPage name="Onboarding Funnel" page={<OnboardingFunnel />} />,
  },
  {
    path: "/cac",
    element: <WrappedPage name="CAC Calculator" page={<CACPage />} />,
  },
  {
    path: "/kpi",
    element: <WrappedPage name="KPI" page={<DashboardKPI />} />,
  },
  {
    path: "/sign-in",
    element: <SignIn />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

const router = createBrowserRouter(routes, {
  basename: import.meta.env.BASE_URL,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
